export default "__VITE_ASSET__MrDs6Y7A__"